import React, { useState, useEffect, Fragment } from 'react'
import axios from 'axios'
import { Button, Modal, ModalBody, ModalHeader, Table } from 'reactstrap'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'

// Import event list components

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import AddSessions from './AddSessions';


const ManageSessions = props => {
    const { eventId } = props

    const [eventSessions, setEventSessions] = useState([])
    const [eventSession, setEventSession] = useState(null)

    const [sessionModal, setSessionModal] = useState(false)


    //Getting all Events using axios
    useEffect(() => {
        if (eventId) {
            getEventSessions(eventId)
        }
    }, [eventId])

    const getEventSessions = async (eventId) => {
        await axios.post('/api/event-sessions/getSessionsByEventId', { eventId, filters: {} }, tokenConfig())
            .then(res => setEventSessions(res.data))
            .catch(err => console.log(err))
    }

    const deleteEventSession = async _id => {
        const confirm = window.confirm("Delete this Event?")
        if (!confirm) return console.log("Cancelled Request")
        await axios.delete(`/api/event-sessions/${_id}`, tokenConfig())
            .then(res => {
                setEventSessions(eventSessions.filter(session => session._id !== _id))
            })
            .catch(err => console.log(err))
    }

    const addToSessionList = newSession => {
        setEventSessions([...eventSessions, newSession])
    }

    const updateSessionList = updatedSession => {
        const updatedSessions = eventSessions.map(e => e._id === updatedSession._id ? updatedSession : e)
        setEventSessions(updatedSessions)
    }
    return (
        <Fragment>
            <Modal isOpen={props.manageSessions} size='lg' toggle={() => props.toggle()}>
                <ModalHeader toggle={() => props.toggle()}>Manage Sessions</ModalHeader>
                <ModalBody>
                    <Button
                        onClick={() => {
                            setSessionModal(true)
                            setEventSession(null)
                        }}
                    >Add Session</Button>
                    <br />
                    <br />
                    <AddSessions
                        eventId={eventId}
                        eventSession={eventSession}
                        sessionModal={sessionModal}
                        toggle={() => setSessionModal(!sessionModal)}
                        addToSessionList={addToSessionList}
                        updateSessionList={updateSessionList}
                    />
                    <Table >
                        <thead>
                            <tr>
                                <th style={{ width: "8%" }} className='rowAlign'>Date</th>
                                <th style={{ width: "8%" }} className='rowAlign'>Start Time</th>
                                <th style={{ width: "8%" }} className='rowAlign'>End Time</th>
                                <th style={{ width: "8%" }} className='rowAlign'>Registrations</th>
                                <th style={{ width: "8%" }} className='rowAlign'>Status</th>
                                <th style={{ width: "8%" }} className='rowAlign'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventSessions.map((session) => {
                                const { _id, date, starttime, endtime, registrations, status, } = session
                                return (
                                    <tr key={_id}>
                                        <td className='rowAlign'>{date ? date.substring(0, 10) : ""}</td>
                                        <td className='rowAlign'>{starttime}</td>
                                        <td className='rowAlign'>{endtime}</td>
                                        <td className='rowAlign'>{registrations}</td>
                                        <td className='rowAlign'>{status}</td>
                                        <td>
                                            <center>
                                                <FontAwesomeIcon
                                                    color='blue'
                                                    className='cursor'
                                                    icon={faEdit}
                                                    onClick={() => {
                                                        setEventSession(session)
                                                        setSessionModal(true)
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    color='red'
                                                    className='cursor'
                                                    style={{ marginLeft: '6px' }}
                                                    icon={faTrash}
                                                    onClick={() => deleteEventSession(session._id)}
                                                />
                                            </center>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
            <br />
            <br />
        </Fragment >
    )
}

export default ManageSessions